import { WIZARD_STEPS } from "./apiServiceWizardTree";

export const WIZARD_RETURN_KEY = "apiServiceWizardReturn";

const MAX_AGE_MS = 24 * 60 * 60 * 1000;

/** Persist wizard state so workbench mapping can return to Translate Data. */
export function saveWizardReturnContext(payload) {
  sessionStorage.setItem(
    WIZARD_RETURN_KEY,
    JSON.stringify({
      ...payload,
      timestamp: Date.now(),
    })
  );
}

export function loadWizardReturnContext() {
  try {
    const raw = sessionStorage.getItem(WIZARD_RETURN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.timestamp || Date.now() - parsed.timestamp > MAX_AGE_MS) {
      clearWizardReturnContext();
      return null;
    }
    return parsed;
  } catch {
    clearWizardReturnContext();
    return null;
  }
}

export function clearWizardReturnContext() {
  sessionStorage.removeItem(WIZARD_RETURN_KEY);
}

/** Overview URL for api_service_manager (no workflow deep-link params). */
export function buildApiServiceManagerOverviewUrl() {
  const params = new URLSearchParams(window.location.search);
  params.set("page", "api_service_manager");
  params.delete("tab");
  params.delete("workflowGroupName");
  params.delete("template");
  params.delete("openMapping");
  params.delete("wizardReturn");
  return `${window.location.pathname}?${params.toString()}`;
}

export function buildWorkbenchWorkflowUrl({ account, workflowGroup, workflowName }) {
  const params = new URLSearchParams(window.location.search);
  params.set("page", "workbench");
  params.set("tab", "workflow");
  params.set("account", account);
  params.set("workflowGroupName", workflowGroup);
  params.set("template", workflowName);
  params.delete("wizardReturn");
  params.delete("openMapping");
  return `${window.location.pathname}?${params.toString()}`;
}

/**
 * Open Workbench workflow in the same tab; push overview URL first so browser Back returns here.
 */
export function openWorkbenchWorkflow({ account, workflowGroup, workflowName }) {
  window.history.pushState({ apiServiceManager: true }, "", buildApiServiceManagerOverviewUrl());
  window.location.href = buildWorkbenchWorkflowUrl({ account, workflowGroup, workflowName });
}

export function buildWorkbenchMappingUrl(translateData) {
  const params = new URLSearchParams(window.location.search);
  params.set("page", "workbench");
  params.set("tab", "outbound");
  params.set("workflowGroupName", translateData.workflowGroup);
  params.set("template", translateData.outboundTemplate);
  params.set("openMapping", "1");
  return `${window.location.pathname}?${params.toString()}`;
}

export function buildApiServiceManagerReturnUrl() {
  const params = new URLSearchParams(window.location.search);
  params.set("page", "api_service_manager");
  params.delete("tab");
  params.delete("workflowGroupName");
  params.delete("template");
  params.delete("openMapping");
  params.set("wizardReturn", "1");
  return `${window.location.pathname}?${params.toString()}`;
}

export function stripWizardReturnParam() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("wizardReturn")) return;
  params.delete("wizardReturn");
  const qs = params.toString();
  window.history.replaceState({}, "", qs ? `${window.location.pathname}?${qs}` : window.location.pathname);
}

export function isWizardReturnStep(step) {
  return step === WIZARD_STEPS.TRANSLATE_DATA;
}
